export default __webpack_public_path__ + "static/media/img6.0f668809.PNG";